import { useContext } from "react";
import { userContext } from "./Profiles";

export default function useAuth() {
    return useContext(userContext);
}